import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CanActivateViaAuthService implements CanActivate {

  constructor(
    private _auth: AuthService,
    private router: Router
  ) {}

  canActivate(): Observable<any> {
    return this._auth.isLoggedIn().switchMap(canActivate => {

       if(canActivate) {
         return Observable.of(true);
       } else {
         this.router.navigate(['/login']);
         return Observable.of(false);
       }
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/services/can-activate-via-auth.service.ts